import { Twitter, Linkedin, Facebook, Link as LinkIcon } from 'lucide-react';

export default function SocialShare({ title, url }) {
  const shareText = `Check out this article about ${title}`;
  const encodedUrl = encodeURIComponent(url);
  const encodedText = encodeURIComponent(shareText);

  const shareLinks = [
    {
      name: 'Twitter',
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
      color: 'hover:bg-sky-100 text-sky-500'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      color: 'hover:bg-blue-100 text-blue-500'
    },
    {
      name: 'Facebook',
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      color: 'hover:bg-indigo-100 text-indigo-500'
    }
  ];

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      alert('Link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  return (
    <div className="flex items-center space-x-4">
      <span className="text-sm font-medium text-slate-600">Share this article:</span>
      <div className="flex items-center space-x-2">
        {shareLinks.map((social) => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`p-2 rounded-full ${social.color} transition-colors`}
            aria-label={`Share on ${social.name}`}
          >
            <social.icon className="w-5 h-5" />
          </a>
        ))}
        <button
          onClick={copyToClipboard}
          className="p-2 rounded-full hover:bg-slate-100 text-slate-500 transition-colors"
          aria-label="Copy link"
        >
          <LinkIcon className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
} 